import React, { useState } from 'react'
import CustomizedDialogs from '../../../common/CustomizedDialogs'
import { Box, Checkbox, Divider, FormControlLabel, Radio } from '@mui/material'
import dayjs from 'dayjs'
import CustomDatePicker from '../../../common/CustomDatePicker'
import MButton from '../../../common/MButton'
import { isCancel } from 'axios'
import DropDownV3 from '../../../common/DropDownV3'
import { useDispatch, useSelector } from 'react-redux'
import { getCompaniesListAllByAgentsAndDate } from '../../../redux/Report/ReportActions'
import { showErrorAlert } from '../../../redux/Actions'
import { encryptText } from '../../../utils/encrypt'

const AgentTicketModal = (props) => {
    const { open = false, titleText = '', onClose = () => { } } = props
    const dispatch = useDispatch();
    const store = useSelector((store) => store);
    const { user } = store;
    const { userDetails } = user;
    const [filterOpt, setFilterOpt] = useState({
        operator: []
    })
    const [filterValue, setFilterValue] = useState({
        isDateFilter: true,
        isCancelled: false,
        operator: [],
        toDate: dayjs(window.getTime ? window.getTime() : new Date()),
        fromDate: dayjs(window.getTime ? window.getTime() : new Date()),
        isLoad: false
    })
    const operatorProps = () => {
        return {
            width: "100%",
            name: "operator",
            id: 'operator',
            label: "Operator",
            isCompulsory: false,
            options: filterOpt.operator || [],
            preSelectedValues: filterValue?.operator || [],
            searchPlaceholder: "Search by Operator",
            disabled: !filterValue.isLoad,
            isObject: true,
            primaryKey: 'CompanyID',
            labelKey: 'CompanyNameWithID',
            singleSelect: true,
            selectAllOption: true,
            defaultAllSelected: true,
            direction: 'up',
            nextId: '',
            prevId: '',
        }
    }



    const handleLoad = () => {
        handleResetLoad()
        const from = filterValue.fromDate;
        const to = filterValue.toDate;

        const diffInDays = to.diff(from, "day");

        if (diffInDays > 7) {
            dispatch(showErrorAlert("Please select a date range of 7 days or less."))
            return;
        }
        const body = {
            fromDate: dayjs(filterValue.fromDate).format('YYYY-MM-DD'),
            Todate: dayjs(filterValue.toDate).format('YYYY-MM-DD'),
            intAgentUserID: userDetails?.AgentUserID || 0,
            intAgentID: userDetails.AgentID || 0,
            isJDatewise: !filterValue.isDateFilter,

        }
        dispatch(getCompaniesListAllByAgentsAndDate(body)).then((res) => {
            if (res.data.status) {
                const parsedData = JSON.parse(res.data.Data || "{}")?.Table || []
                setFilterOpt((prev) => ({
                    ...prev,
                    operator: parsedData
                }))
                setFilterValue((prev) => ({
                    ...prev,
                    isLoad: true,
                    operator: parsedData
                }))
            } else {
                dispatch(showErrorAlert(res.data.Message || 'Failed to load operators'))
            }
        })
    }

    const handleResetLoad = () => {
        setFilterValue((prev) => ({
            ...prev,
            isLoad: false,
            operator: []
        }))
    }
    return (

        <CustomizedDialogs
            open={open}
            titleText={titleText}
            width={'450px'}
            height={'auto'}
            onClose={onClose}
            padding={'0px'}
        >

            <Box sx={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <Box>
                    <FormControlLabel
                        control={
                            <Radio
                                checked={filterValue.isDateFilter}
                                sx={{
                                    '&.Mui-checked': {
                                        color: '#0086FF',
                                    },
                                    padding: '0px',
                                    paddingLeft: '10px',
                                    marginRight: '6px',
                                }}
                                onChange={(e) => {
                                    setFilterValue((prev) => ({
                                        ...prev,
                                        isDateFilter: true
                                    }))
                                    handleResetLoad()
                                }}
                            />
                        }
                        label='Transaction Date'
                    />
                    <FormControlLabel
                        control={
                            <Radio
                                checked={filterValue.isDateFilter === false}
                                sx={{
                                    '&.Mui-checked': {
                                        color: '#0086FF',
                                    },
                                    padding: '0px',
                                    paddingLeft: '10px',
                                    marginRight: '6px',
                                }}
                                onChange={(e) => {
                                    setFilterValue((prev) => ({
                                        ...prev,
                                        isDateFilter: false
                                    }))
                                    handleResetLoad()
                                }}
                            />
                        }
                        label='Journey Date'
                    />
                </Box>
                <Box className='date_pickerV40'>
                    <CustomDatePicker label='From Date' id='journey_Date' selectedDate={filterValue.fromDate}
                        onChange={(date) => {
                            if (new Date(date) < new Date(filterValue.toDate)) {
                                setFilterValue({ ...filterValue, fromDate: date })
                            } else {
                                setFilterValue({ ...filterValue, fromDate: date, toDate: date })
                            }
                            handleResetLoad()
                        }}
                        minDate={null}
                    />
                </Box>
                <Box className='date_pickerV40'>
                    <CustomDatePicker label='To Date' id='journey_Date' selectedDate={filterValue.toDate}
                        onChange={(date) => {
                            setFilterValue((prev) => ({
                                ...prev,
                                toDate: date
                            }))
                            handleResetLoad()
                        }}
                        minDate={filterValue.fromDate}
                    />
                </Box>
                <Box>
                    <MButton
                        btnName='Load'
                        className='btn-orange btn-full-width'
                        onClick={handleLoad}
                    />
                </Box>
                <Box>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={filterValue.isCancelled}
                                sx={{
                                    '&.Mui-checked': {
                                        color: '#0086FF',
                                    },
                                    padding: '0px',
                                    paddingLeft: '10px',
                                    marginRight: '6px',
                                }}
                                onChange={(e) => {
                                    setFilterValue((prev) => ({
                                        ...prev,
                                        isCancelled: !prev.isCancelled
                                    }))
                                }}
                            />
                        }
                        label='Add Cancellation'
                    />
                </Box>
                <Box>
                    <DropDownV3
                        {...operatorProps()}
                        onSelect={(val) => {
                            setFilterValue((prev) => ({
                                ...prev,
                                operator: val
                            }))
                        }}
                    />
                </Box>

            </Box>
            <Divider sx={{ borderColor: '#cccccc' }} />
            <Box sx={{ display: 'flex', justifyContent: 'end', gap: '8px', padding: '12px 16px' }}>
                <MButton variant='outlined' btnName="Close" onClick={onClose} />
                <MButton btnName="Generate"
                    disabled={!filterValue.isLoad}
                    onClick={() => {
                        const params = {
                            userId: userDetails?.AgentUserID || 0,
                            blnIsJDate: !(filterValue.isDateFilter),
                            FromDate: filterValue.fromDate.format('YYYY-MM-DD'),
                            ToDate: filterValue.toDate.format('YYYY-MM-DD'),
                            companyID: filterValue.operator?.length === 1 ? filterValue.operator?.[0]?.CompanyID : 0,
                            agentID: userDetails.AgentID,
                            isCancel: filterValue.isCancelled || false,
                            operatorName: filterValue.operator?.length === 1 ? filterValue.operator?.[0]?.CompanyName : 'All Operators'
                        }
                        window.open(`/agentTicketReport?data=${encodeURIComponent(encryptText(JSON.stringify(params)))}`, "_blank");
                    }}
                />
            </Box>
        </CustomizedDialogs>
    )
}

export default AgentTicketModal